<!-- =========================================================================================
    File Name: TableAltri.vue
    Description: Table show on Altri documenti
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: · | ·· | ·
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <search-bar @create-documento="handleNewDocumento" @find="cercaDocumento" :p="{current:this.page, tot:this.tot_page}" :newTexts="['Documento']" :tipo="['documento']" tooltip="Categoria, Azienda ragione sociale"></search-bar>
      <!-- <vs-table @next="nextPage" @prev="prevPage" v-model="selected" @selected="handleSelected" :page="page" :hasNext="hasNext" :pagination="documenti.length >= elements_per_page" :max-items="elements_per_page" :data="documenti"> -->
      <vs-table @next="nextPage" @prev="prevPage" :page="page" :hasNext="hasNext" :custom_pager="{current:this.page, tot:this.tot_page}" :pagination="documenti.length >= elements_per_page || page != 1" :max-items="elements_per_page" :data="documenti">
          <template slot="thead">
            <vs-th :key="i" v-for="(e, i) in ['Cliente', 'Categoria', 'Descrizione', 'Data scadenza', '']">{{e}}</vs-th>
          </template>
          <template slot-scope="{data}">
              <vs-tr v-if="documenti.length > 0" class="shadow row-no-pointer" :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="tr.numero" :key="1">
                      {{tr.azienda ? tr.azienda.ragione_sociale : tr.contatto ? [tr.contatto.cognome,tr.contatto.nome].join(' ') : tr.tirocinio ? tr.tirocinio.azienda.ragione_sociale : ''}}
                  </vs-td>

                  <vs-td :data="data[indextr].cliente" :key="2">
                      {{tr.categoria}}
                  </vs-td>
                  <vs-td :data="data[indextr].descrizione" :key="3">
                      {{tr.descrizione}}
                  </vs-td>
<!-- aggiungere class al td, colorare testo in base alla scadenza -->
                  <vs-td :data="data[indextr].servizio" :key="4">
                      {{tr.data_scadenza ? $tariffe.formatDateNew(tr.data_scadenza) : ""}}
                  </vs-td>

                  <vs-td>
                    <vs-row v-if="tr.azienda || tr.tirocinio || tr.contatto" vs-justify="flex-end">
                      <vx-tooltip text="Scarica">
                        <vs-button @click="downloadFile(tr, $event)" radius color="primary" type="line" size="small" icon-pack="feather" icon="icon-download"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Modifica">
                        <vs-button @click="handleSelected(tr)" class="ml-2" radius color="warning" type="line" size="small" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Elimina">
                        <vs-button @click="handleEliminaDocumento(tr.id)" class="ml-2" radius color="danger" size="small" type="line" icon-pack="feather" icon="icon-trash"></vs-button>
                      </vx-tooltip>
                    </vs-row>
                    <!-- <vs-row v-if="tr.contratto" vs-justify="flex-end">
                      <vx-tooltip text="Scarica">
                        <vs-button @click="getContr(tr, $event)" radius color="primary" type="line" icon-pack="feather" icon="icon-download"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Elimina">
                        <vs-button @click="delContr(tr.id)" class="ml-2" radius color="danger" type="line" icon-pack="feather" icon="icon-trash"></vs-button>
                      </vx-tooltip>
                    </vs-row> -->
                  </vs-td>

              </vs-tr>
          </template>
      </vs-table>
      <vs-sidebar click-not-close position-right parent="body" color="primary" class="sidebarx sidebarpage sidebar-utenti" spacer v-model="sidebar_active">
        <sidebar-new-documento @close-me="sidebarClose" @elimina="handleEliminaDocumento" @documento-creato="handleDocumentoCreato" :key="Math.random()" :selected="_.cloneDeep(selected)"></sidebar-new-documento>
      </vs-sidebar>
  </div>
</template>

<script>
import axios from 'axios'
import SidebarNewDocumento from './SidebarNewDocumento.vue'
import SearchBar from '../commons/SearchBar.vue'

export default {
    data() {
        return {
          selected: null,

          sidebar_active: false,
          documenti: [],

          formkey: Math.random(),

          keyword: "",
          page: 1,
          tot_page: 0,
          elements_per_page: 15,
          hasNext: false,
        }
    },
    components: {
      SidebarNewDocumento,
      SearchBar,
    },
    mounted () {
      this.getDocumenti()
    },
    methods: {
      getDocumenti() {
        this.activeLoading = true
        this.$vs.loading({
          type:'radius',
        })
        axios.post(process.env.VUE_APP_BACKEND_API+'/azienda/documento/trova_tutti_documenti', {
          pag: this.page,
          keyword: this.keyword,
          take: this.elements_per_page
        },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
        })
        .then(response => {
          if (response.data.length == 0) {  this.documenti = []
                                            this.hasNext = false }
          else {
            this.documenti = response.data.res
            this.hasNext = this.documenti.length >= this.elements_per_page
            this.tot_page = Math.ceil(response.data.count / this.elements_per_page)
            // this.selected = this.selected ? this.documenti.find( a => a.id == this.selected.id) : {}
          }
          this.$vs.loading.close()
        })
        .catch(e => {
          console.log(e)
          this.$vs.loading.close()
        })
      },
      nextPage() {
        if (this.page < this.tot_page) {
          this.page += 1
          this.getDocumenti()
        }
      },
      prevPage() {
        this.page -= 1
        this.getDocumenti()
      },
      handleNewDocumento() {
        if (this.selected) {
          this.selected = null
        }
        this.formkey = Math.random()
        this.sidebar_active = true
      },
      handleDocumentoCreato(message) {
        // if (message === 'OK') {
          this.sidebar_active = false
          this.formkey = Math.random()
          // console.log(this.$router);
          this.$router.go()
          // this.page = 1
          // this.keyword = ""
          // this.selected = null
          // this.getDocumenti()
          // console.log(message);
        // }
      },
      handleEliminaDocumento(id) {
        this.formkey = Math.random()
        axios.post(process.env.VUE_APP_BACKEND_API+'/azienda/documento/elimina', { id: id },{
            headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
            withCredentials: true,
          })
          .then(response => {
            this.sidebar_active = false
            this.message = response.data
            this.formkey = Math.random()
            this.getDocumenti()
            this.selected = null
          } )
          .catch(e => console.log(e))
      },
      cercaDocumento(k) {
        this.keyword = k
        this.page = 1
        this.getDocumenti()
      },
      handleSelected(doc) {
        // if(this.selected) {
          this.selected = _.cloneDeep(doc)
          this.formkey = Math.random()
          this.sidebar_active = true
        // }
      },
      downloadFile(doc,ev) {
        this.activeLoading = true
        this.$vs.loading({
          type:'radius',
        })
        axios.post(process.env.VUE_APP_BACKEND_API+'/azienda/documento/download', {
          id: doc.id,
          nuovo_nome: doc.nuovo_nome,
          nome: doc.nome,
        },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
          responseType: 'blob'
        })
        .then(
          response => {
          const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
          const link = document.createElement('a');
          link.href = url
          this.$vs.loading.close()
          link.setAttribute('download', response.headers['x-file-name']);
          document.body.appendChild(link);
          link.click();
        }
        ).catch(e => {
          console.log(e)
          this.$vs.loading.close()
        })
        ev.stopPropagation()
      },
      sidebarClose() {
        this.selected = null
        this.sidebar_active = false
      }
    },
    // watch: {
    //   sidebar_active() {
    //     console.log('active cambiato: ',this.sidebar_active,Math.ceil(Math.random()*100));
    //   },
    //   selected() {
    //     console.log('selected: ',this.selected,Math.ceil(Math.random()*100));
    //   }
    // },
}
</script>
